import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { applyRobots, removePrerenderedJsonLd } from "@/hooks/useSeo";

/**
 * Al navegar dentro de la SPA (no en la primera carga), retira lo que traía el
 * HTML prerenderizado de la página de aterrizaje —JSON-LD, bloque de contenido
 * estático— y pone canonical y robots de la ruta nueva. Las páginas con
 * useDocumentMeta los ajustan después; las que no lo usan (legales) ya no
 * heredan los de la página anterior.
 *
 * Debe ir antes que <Routes> en el árbol: sus efectos corren antes que los de
 * la página.
 */
export function SeoRouteReset() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    removePrerenderedJsonLd();
    document.querySelectorAll(".prerender-seo").forEach((el) => el.remove());
    applyRobots({});
  }, [pathname]);
  return null;
}
